import { render, staticRenderFns } from "./stock-transfer-v2.vue?vue&type=template&id=3ee06f77&"
import script from "./stock-transfer-v2.vue?vue&type=script&lang=js&"
export * from "./stock-transfer-v2.vue?vue&type=script&lang=js&"
import style0 from "./stock-transfer-v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports